import CityPageTemplate from "../city-template/CityPageTemplate";
import { fairmontConfig } from "./data";

export default function FairmontPage() {
  return <CityPageTemplate config={fairmontConfig} />;
}